const indexItems = [
  { label: '动作大片', icon: 'ri-sword-line', count: '326部', color: 'accent' },
  { label: '喜剧剧场', icon: 'ri-emotion-laugh-line', count: '218部', color: 'primary' },
  { label: '悬疑推理', icon: 'ri-search-eye-line', count: '167部', color: 'secondary' },
  { label: '爱情文艺', icon: 'ri-heart-line', count: '193部', color: 'accent' },
  { label: '科幻冒险', icon: 'ri-rocket-line', count: '142部', color: 'primary' },
  { label: '恐怖惊悚', icon: 'ri-ghost-line', count: '89部', color: 'secondary' },
  { label: '动漫番剧', icon: 'ri-ancient-gate-line', count: '275部', color: 'accent' },
  { label: '纪录片', icon: 'ri-earth-line', count: '156部', color: 'primary' },
  { label: '综艺娱乐', icon: 'ri-tv-line', count: '204部', color: 'secondary' },
];

const colorMap: Record<string, { bg: string; text: string; border: string }> = {
  accent: {
    bg: 'bg-accent-500/10',
    text: 'text-accent-400',
    border: 'border-accent-500/20 hover:border-accent-500/50',
  },
  primary: {
    bg: 'bg-primary-500/10',
    text: 'text-primary-400',
    border: 'border-primary-500/20 hover:border-primary-500/50',
  },
  secondary: {
    bg: 'bg-secondary-500/10',
    text: 'text-secondary-400',
    border: 'border-secondary-500/20 hover:border-secondary-500/50',
  },
};

export default function SectionIndex() {
  return (
    <section id="index" className="py-16 md:py-20 px-4 md:px-8 bg-background-50">
      <div className="max-w-[1200px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-50 mb-3">
            影视索引
          </h2>
          <p className="text-sm text-foreground-400">按类型快速找到你想看的内容</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-3 md:gap-4">
          {indexItems.map((item, i) => {
            const c = colorMap[item.color];
            return (
              <a
                key={i}
                href="#cards"
                className={`flex items-center gap-3 p-4 md:p-5 rounded-lg border bg-background-100/60 transition-all cursor-pointer ${c.border}`}
              >
                <span className={`w-10 h-10 md:w-11 md:h-11 flex items-center justify-center rounded-lg shrink-0 ${c.bg}`}>
                  <i className={`${item.icon} ${c.text} text-lg`}></i>
                </span>
                <div className="min-w-0">
                  <div className="text-sm md:text-base font-medium text-foreground-200 whitespace-nowrap">
                    {item.label}
                  </div>
                  <div className="text-xs text-foreground-500 mt-0.5">{item.count}</div>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}